import { getTimezones } from '@/api/timezones';
import { useQuery } from '@tanstack/react-query';

const timezoneKeys = {
	allTimezone: () => ['all_timezones'] as const,
};

export const useTimezones = ({ enabled }: { enabled?: boolean } = {}) =>
	useQuery({
		queryKey: timezoneKeys.allTimezone(),
		queryFn: () => getTimezones(),
		enabled,
		refetchOnWindowFocus: false,
		keepPreviousData: true,
	});
